/* eslint-disable max-len */
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import qs from 'qs';
import React from 'react';
import { connect } from 'react-redux';
import { WEARABLE_ALARMS_STATUS } from '../../_config/consts';
import { localizeHelpCenterLink } from '../../_config/utils.js';
import AlarmIconCustom from '../../components/CustomIcons/AlarmIconCustom.jsx';
import TranslatableOption from '../../components/forms/Fields/TranslatableOption.jsx';
import PresentationalViewHeader from '../../components/PresentationalView/PresentationalViewHeader.jsx';
import WearableAlarmsTableView from '../../components/Wearable/WearableAlarmsTableView.jsx';
import * as ModalActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import * as WearableActions from '../../redux/actions/wearable.actions';

let filterTimeout;

@connect((state) => ({
  routing: state.router,
  wearables: state.wearables,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
}))
class WearableAlarmsManagement extends React.Component {

  async componentDidMount() {
    const { dispatch, routing } = this.props;
    const parsed = qs.parse(routing.location.search, { ignoreQueryPrefix: true });
    const wearableId = parsed.wearableId;
    dispatch(WearableActions.resetWearableAlarmsFilters());
    if (wearableId) {
      dispatch(WearableActions.setWearableAlarmsFilter('wearableId', wearableId));
    }
    
    this.onFetchWearableAlarms();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(WearableActions.resetWearableAlarmsData());
  }

  async onFetchWearableAlarms() {
    const { dispatch } = this.props;
    const alarms = await dispatch(WearableActions.fetchWearableAlarms(null));
    const activeAlarms = _.filter(alarms, alarm => alarm.status === WEARABLE_ALARMS_STATUS.ACTIVE);
    dispatch(WearableActions.saveActiveAlarms(activeAlarms));
  }

  onRefreshWearableAlarms() {
    this.onFetchWearableAlarms();
  }

  async onFetchWearableAlarmsOnPage(page) {
    const { dispatch } = this.props;
    const alarms = await dispatch(WearableActions.fetchWearableAlarms(null, page));
    const activeAlarms = _.filter(alarms, alarm => alarm.status === WEARABLE_ALARMS_STATUS.ACTIVE);
    dispatch(WearableActions.saveActiveAlarms(activeAlarms));
  }

  onResetWearableAlarmsFilters() {
    const { dispatch } = this.props;
    dispatch(WearableActions.resetWearableAlarmsFilters());
    this.onFetchWearableAlarms();
  }

  onDateRangeSelected(startDate, endDate) {
    const { dispatch } = this.props;
    const finalStartDate = startDate ? moment(startDate).startOf('day').valueOf() : null;
    const finalEndDate = endDate ? moment(endDate).endOf('day').valueOf() : null;
    
    dispatch(WearableActions.setWearableAlarmsFilter('fromDate', finalStartDate));
    dispatch(WearableActions.setWearableAlarmsFilter('toDate', finalEndDate));
    
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      this.onFetchWearableAlarms();
    }, 500);
  }

  onSelectStatus(status) {
    const { dispatch } = this.props;
    const statusValue = status && status !== 'ALL' ? status : null;
    dispatch(WearableActions.setWearableAlarmsFilter('status', statusValue));
    
    if (filterTimeout) clearTimeout(filterTimeout);
    filterTimeout = setTimeout(async () => {
      this.onFetchWearableAlarms();
    }, 500);
  }

  onSetFilter(field, value) {
    const { dispatch } = this.props;
    if (value && ((_.isNumber(value) && value >= 1) || (_.isArray(value) && !_.isEmpty(value)) || (_.isString(value) && value.length >= 2))) {
      dispatch(WearableActions.setWearableAlarmsFilter(field, value));
      if (filterTimeout) clearTimeout(filterTimeout);
      filterTimeout = setTimeout(async () => {
        this.onFetchWearableAlarms();
      }, 500);
    } else {
      dispatch(WearableActions.setWearableAlarmsFilter(field, null));
      this.onFetchWearableAlarms();
    }
  }

  onShowWearableAlarmsInfoPage() {
    const helpURL = localizeHelpCenterLink('wearables');
    window.open(helpURL);
  }

  async onSilenceAlarm(alarmId) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      await dispatch(WearableActions.updateWearableAlarm(alarmId, { status: 'RESOLVED' }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchWearableAlarms();
      await dispatch(WearableActions.fetchActiveAlarms());
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="alarmSilencedSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="alarmActionError" /></h6>),
        },
      }));
    }
  }

  async onSilenceAlarmsBatch(alarms) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const alarmIds = _.map(alarms, alarm => alarm.id);
      await Promise.all(alarmIds.map(alarmId => 
        dispatch(WearableActions.updateWearableAlarm(alarmId, { status: 'RESOLVED' }))
      ));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      this.onFetchWearableAlarms();
      await dispatch(WearableActions.fetchActiveAlarms());
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="alarmsSilencedSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="alarmActionError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { wearables, themeName, viewLoading } = this.props;
    const numberOfAlarms = wearables && wearables.alarms && wearables.alarms.pagination && wearables.alarms.pagination.totalElements ? wearables.alarms.pagination.totalElements : 0;
    const { fromDate, toDate, status } = wearables?.alarms?.filters || {};

    const statusOptions = [
      { value: 'ALL', label: 'all' },
      { value: WEARABLE_ALARMS_STATUS.ACTIVE, label: 'active' },
      { value: WEARABLE_ALARMS_STATUS.RESOLVED, label: 'resolved' },
    ];

    const datesHelpersOptions = [
      {
        title: L20NContext.getSync('today'),
        startDate: moment().startOf('day').valueOf(),
        endDate: moment().endOf('day').valueOf(),
      },
      {
        title: L20NContext.getSync('thisWeek'),
        startDate: moment().startOf('week').valueOf(),
        endDate: moment().endOf('week').valueOf(),
      },
      {
        title: L20NContext.getSync('thisMonth'),
        startDate: moment().startOf('month').valueOf(),
        endDate: moment().endOf('month').valueOf(),
      }
    ];

    return (
      <div>
        <PresentationalViewHeader
          themeName={themeName}
          resetButtonContainerStyle={{ marginLeft: 50 }}
          searchPlaceholderEntityName="searchWearableAlarm"
          searchNameContainerStyle={{ width: 220 }}
          containerStyle={{ height: 110}}
          isLoading={viewLoading}
          onFilterChange={value => this.onSetFilter('type', _.trim(value))}
          onSearchReset={() => this.onResetWearableAlarmsFilters()}
          onInfo={() => this.onShowWearableAlarmsInfoPage()}
          numberOfElements={numberOfAlarms}
          onDatesChange={(startDate, endDate) => this.onDateRangeSelected(startDate, endDate)}
          startDate={fromDate ? moment(fromDate) : moment().startOf('month')}
          endDate={toDate ? moment(toDate) : moment().endOf('month')}
          datesHelpersOptions={datesHelpersOptions}
          selectableFieldName="status"
          onSelectOption={option => this.onSelectStatus(option)}
          selectableOptions={_.map(statusOptions, option =>
            <Entity
              key={option.value}
              componentClass={TranslatableOption}
              value={option.value}
              componentAttribute="text"
              entity={option.label}
            />
          )}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <AlarmIconCustom style={{ width: 25 }} />
              <h4 style={{ marginTop: 0 }}>{numberOfAlarms}</h4>
            </div>
          }
        />
        <WearableAlarmsTableView
          onRefreshWearableAlarms={() => this.onRefreshWearableAlarms()}
          onFetchWearableAlarmsOnPage={page => this.onFetchWearableAlarmsOnPage(page)}
          onSilenceAlarm={alarmId => this.onSilenceAlarm(alarmId)}
          onSilenceAlarmsBatch={alarms => this.onSilenceAlarmsBatch(alarms)}
        />
      </div>
    );
  }
} 

export default WearableAlarmsManagement;
